export default "__VITE_ASSET__Cak4keWm__"